const Header = require('./Header').default
const HeaderItem = require('./HeaderItem').default
const Body = require('./Body').default

export default {
  Header,
  HeaderItem,
  Body
}
